<template>
    <div class="countdown">
        <span class="number">{{ days }}</span
        ><span class="label">天</span>
        <span class="number" :class="{ 'number-font': isMobile }">{{
            formatNumber(hours)
        }}</span
        ><img
            class="label2"
            src="https://m.elongstatic.com/year-wish/countdown-unit-guide.png"
        />
        <span class="number" :class="{ 'number-font': isMobile }">{{
            formatNumber(minutes)
        }}</span
        ><img
            class="label2"
            src="https://m.elongstatic.com/year-wish/countdown-unit-guide.png"
        />
        <span class="number" :class="{ 'number-font': isMobile }">{{
            formatNumber(seconds)
        }}</span>
    </div>
</template>

<script>
export default {
    props: {
        endDate: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            intervalId: null,
            isMobile: false, // 判断是否是移动端
        };
    },
    mounted() {
        this.calculateTimeLeft();
        this.intervalId = setInterval(this.calculateTimeLeft, 1000);
        this.isMobile = window.innerWidth <= 500 ? true : false;
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
    methods: {
        formatNumber(value) {
            const newvalue = Number(value);
            return newvalue < 10 ? "0" + newvalue : value;
        },
        calculateTimeLeft() {
            const now = new Date().getTime();
            const distance = new Date(this.endDate).getTime() - now;
            // 判断distance是否是有效数字
            if (isNaN(distance)) {
                return;
            }

            if (distance < 0) {
                clearInterval(this.intervalId);
                this.days = 0;
                this.hours = 0;
                this.minutes = 0;
                this.seconds = 0;
                return;
            }

            this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
            this.hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
        },
    },
};
</script>

<style scoped>
@font-face {
    font-family: "numFont";
    src: url("https://m.elongstatic.com/mall-v2/paint-ai-miniprogram/num_fam.OTF")
        format("truetype"); /* 字体文件的路径 */
}
.countdown {
    margin-top: 24px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* font-size: 1.5em; */
    color: #333;
    gap: 20px;
}
.countdown span {
    /* margin-right: 10px; */
}
.number {
    width: 64px;
    height: 60px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 241, 209, 0);
    border-radius: 20px;
    line-height: 60px;
    display: inline-block;
    font-size: 50px;
    font-weight: 700;
    text-align: CENTER;
    color: #ffe19f;
    padding: 0px;
}
.number-font {
    font-family: numFont;
}
.label {
    width: 40px;
    height: 40px;
    /* background: #ffffff; */
    border: 1px solid rgba(255, 241, 209, 0);
    font-size: 40px;
    font-family: PingFang TC, PingFang TC-400;
    font-weight: 400;
    text-align: CENTER;
    color: #ffffff;
    line-height: 40px;
}
.label2 {
    width: 10px;
    height: 26px;
}
</style>
